<template lang='pug'>
  h1 FAVLIST
</template>

<script>
export default { name: 'HomeTitle' };
</script>
